export default __webpack_public_path__ + "static/media/12.f5962a7c.png";